<template>
  <div>
    <table border="1" class="table" bordercolor="#ebeef4">
      <tr style="background:#F3E8E3">
        <th>编号</th>
        <th>项目</th>
        <th>记账月份</th>
        <th>实际消耗月份</th>
        <th>达人账号</th>
        <th>上线时间</th>
        <th>合作形式</th>
        <th>实际消耗</th>
        <th>开票次数</th>
        <th>首次开票比例(小数)</th>
        <th>首次开票金额</th>
        <th>尾款开票金额</th>
        <th>价格合计</th>
      </tr>
      <template v-for="(items,ind) in dataInfo.order.list">
        <tr v-for="(item,index) in items.row" :key="ind+'tr'+index+'row'">
          <td>{{index+1}}</td>
          <td>{{item.proejct_name}}</td>
          <td>{{item.month}}</td>
          <td>{{item.order_original_month}}</td>
          <td>{{item.internet_celebrity_name}}</td>
          <td>{{item.uptime}}</td>
          <td>{{item.form_of_cooperation}}</td>
          <td>{{$formatNum(item.actual_consumption)}}</td>
          <td>{{item.billing_times}}</td>
          <td>{{item.first_invoicing_ratio}}</td>
          <td>{{$formatNum(item.first_invoiced_amount)}}</td>
          <td>{{$formatNum(item.final_invoiced_amount)}}</td>
          <td>{{$formatNum(item.total_amount)}}</td>
        </tr>
        <tr style="background:#f4f7fa" :key="ind+'tr1'">
          <td colspan='7'>{{items.sort_month}}小计</td>
          <td>{{$formatNum(items.actual_consumption)}}</td>
          <td>{{items.billing_times}}</td>
          <td>{{items.first_invoicing_ratio}}</td>
          <td>{{$formatNum(items.first_invoiced_amount)}}</td>
          <td>{{$formatNum(items.final_invoiced_amount)}}</td>
          <td>{{$formatNum(items.total_amount)}}</td>
        </tr>
        <tr v-if="ind + 1 == dataInfo.order.list.length" :key="ind+tr2">
          <td colspan='7' style="color:#393d64;font-weight:500;">总金额</td>
          <td>{{$formatNum(dataInfo.order.total.actual_consumption)}}</td>
          <td>{{dataInfo.order.total.billing_times}}</td>
          <td>{{dataInfo.order.total.first_invoicing_ratio}}</td>
          <td>{{$formatNum(dataInfo.order.total.first_invoiced_amount)}}</td>
          <td>{{$formatNum(dataInfo.order.total.final_invoiced_amount)}}</td>
          <td>{{$formatNum(dataInfo.order.total.total_amount)}}</td>
        </tr>
      </template>
    </table>
  </div>
</template>
<script>
export default {
  props: ['dataInfo'],
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@import "../statementTemplate/statementDetail.scss";
table {
  tr {
    td {
      &:nth-last-of-type(1),
      &:nth-last-of-type(2),
      &:nth-last-of-type(3),
      &:nth-last-of-type(6) {
        text-align: right;
      }
    }
  }
}
</style>
<style lang="scss">
.statementToast {
  .el-form-item__content {
    font-size: 12px !important;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0 !important;
  }
  .table .el-input__inner {
    padding: 0 !important;
    text-align: center !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/examine/pddStatement.vue